import { Checkbox } from "@fluentui/react/lib/Checkbox";
import { Link } from "@fluentui/react/lib/Link";
import { TooltipHost } from "@fluentui/react/lib/Tooltip";
import { FilterToolTipContent } from "Components/Generic/FilterToolTipContent";

import { WithTranslator } from "Components/Generic/Translator";
import {
  dateFromString, formatDate, isNeverDate, utcNowAsISO
} from "Utils/Date";
import { getTranslatedFieldLabel } from "Utils/Field";
import { getItemType } from "Utils/Item";
import { isNotNullOrWhiteSpace } from "Utils/String";
import { useCheckboxRendererStyles } from "./UseCheckboxRendererStyles";
import { ICheckboxRendererProps } from "./ICheckboxRendererProps";
import { TooltipCloseDelay, TooltipOpenDelay } from "../TooltipSettings";

export const CheckboxRenderer = WithTranslator((props: ICheckboxRendererProps): JSX.Element => {
  const {
    item, fieldName, dateFieldName, urlFieldName, translator, styles
  } = props;
  const styleSet = useCheckboxRendererStyles(styles);

  const hasDate = isNotNullOrWhiteSpace(dateFieldName);
  const date = dateFromString(item?.[dateFieldName]);
  const hasUrl = isNotNullOrWhiteSpace(urlFieldName) && isNotNullOrWhiteSpace(item?.[urlFieldName] as string);
  const rawValue = isNeverDate(item?.[dateFieldName] as string) ? `>=${utcNowAsISO()}` : item?.[dateFieldName];
  const toolTipContent = (hasDate || hasUrl) && (
    <ul className={styleSet.tooltip}>
      {hasDate && (
        <li>
          <FilterToolTipContent
            fieldName={dateFieldName}
            value={`${getTranslatedFieldLabel(dateFieldName, getItemType(item), translator)}: ${
              date == null ? translator.get(`generic.never`, `Never`) : formatDate(translator.getActiveLocale(), date)
            }`}
            rawValue={rawValue}
          />
        </li>
      )}
      {hasUrl && (
        <li>
          <Link href={item?.[urlFieldName] as string} target="_blank">
            {getTranslatedFieldLabel(urlFieldName, getItemType(item), translator)}
          </Link>
        </li>
      )}
    </ul>
  );

  return (
    <TooltipHost
      closeDelay={TooltipCloseDelay}
      content={toolTipContent}
      delay={TooltipOpenDelay}
      hostClassName={styleSet.host}
    >
      <div className={styleSet.root}>
        <Checkbox disabled checked={(item?.[fieldName] as boolean) ?? false} />
      </div>
    </TooltipHost>
  );
});
